import styled from 'styled-components';
import { useEffect } from 'react';
import Head from 'next/head';

import { ContextTypes } from '../types/ContextTypes';
import { getContract } from '../services/server/consents';
import ContractText from '../components/TermsAndConditions/ContractText';
import CONTRACTS from '../constants/CONTRACTS';
import { wrapper } from '../store';
import { gtagScript } from 'scripts/analytics';

interface TermsTypes {
  termsContent: string;
  candidateId: string;
}

const TermsTextContainer = styled.div`
  margin: 2vh 2vw;
`;

const Terms = ({ termsContent, candidateId }: TermsTypes) => {
  return (
    <>
      <Head>
        <script
          id="gtag-function-script"
          async
          dangerouslySetInnerHTML={{
            __html: gtagScript(candidateId),
          }}
        />
      </Head>
      <TermsTextContainer id="terms-and-conditions-phrase">
        <ContractText content={termsContent} />
      </TermsTextContainer>
    </>
  );
};

Terms.getInitialProps = wrapper.getInitialPageProps(
  () =>
    async ({ req }: ContextTypes) => {
      const { candidate } = req;
      const candidateId = candidate ? candidate.id : '0';

      const termsData = await getContract({
        candidateId,
        version: req.query.version && req.query.version.toString(),
        contractType: CONTRACTS.TERMS_AND_CONDITIONS,
        transactionId: req.transactionId,
      });

      return {
        termsContent: termsData && termsData.content ? termsData.content : '',
        candidateId,
      };
    }
);

export default Terms;
// @refresh reset
